import actionTypes from '../actionTypes';

const initialState = {
    hasTenant: false,
    currentTenant: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_TENANT:
            return {
                ...state,
                hasTenant: true,
                currentTenant:  action.payload
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// /src/store/reducers/tenant.js